import { v4 as uuidv4 } from "uuid";

export const generateDeviceID = () =>
    localStorage.setItem("deviceID", uuidv4());
